import { message } from 'antd'
import { TrackingApi } from '../../../../api/Tracking'
import TrackingLines from '../../../../components/Main/Tracking/Lines/TrackingLines'
import React from 'react'

import useFetchList from '../../../../elements/Hooks/useFetchList'
import useModalData from '../../../../elements/Hooks/useModalData'

function TrackingLinesCont (props) {
  const { tracking } = props
  const { list, fetching, fetch } = useFetchList(() => TrackingApi.getLinesByTracking(tracking._key))

  const {
    visible,
    modalType,
    object: line,
    submitting,
    setSubmitting,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
  } = useModalData(undefined, TrackingApi.lines.update, TrackingApi.lines.remove, fetch)

  async function submit () {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await TrackingApi.lines.create({ ...newObject, tracking: tracking._id })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <TrackingLines
      {...{
        list,
        fetching,
        fetch,
        visible,
        submitting,
        tracking,
        line,
        onShow,
        onCancel,
        submit,
        removing,
        remove,
        update,
        modalType,
        formRef,
      }}
    />
  )
}

TrackingLinesCont.propTypes = {}
TrackingLinesCont.defaultProps = {}

export default (TrackingLinesCont)
